module.exports = __webpack_public_path__ + "img/He_Chuan.812daff7.png";